import React from "react";

const COLORS = ["#6366f1", "#10b981", "#f59e0b", "#ef4444", "#3b82f6"];

const ChildSwitcher = ({ items, activeId, onChange }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="flex gap-3 flex-wrap mb-1">
      {items.map((child, idx) => {
        const isActive = child.id === activeId;
        const color = COLORS[idx % COLORS.length];
        const initials = (child.full_name || "?")
          .split(" ")
          .map((w) => w[0])
          .join("")
          .toUpperCase()
          .slice(0, 2);

        return (
          <button
            key={child.id}
            onClick={() => onChange(child.id)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.6rem",
              padding: "0.5rem 1rem 0.5rem 0.5rem",
              border: `2px solid ${isActive ? color : "var(--surface-border)"}`,
              borderRadius: "2rem",
              background: isActive ? `${color}18` : "var(--surface-card)",
              cursor: "pointer",
              transition: "all 0.15s",
              outline: "none",
              fontFamily: "inherit",
            }}
          >
            {/* Avatar circle */}
            <span
              style={{
                width: "2rem",
                height: "2rem",
                borderRadius: "50%",
                background: isActive ? color : "var(--surface-300)",
                color: isActive ? "#fff" : "var(--text-color-secondary)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "0.75rem",
                fontWeight: 700,
                flexShrink: 0,
              }}
            >
              {initials}
            </span>

            {/* Name + Grade */}
            <span style={{ textAlign: "left" }}>
              <div
                style={{
                  fontSize: "0.875rem",
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? color : "var(--text-color)",
                  lineHeight: 1.2,
                }}
              >
                {child.full_name}
              </div>
              {child.currentGrade?.name && (
                <div
                  style={{
                    fontSize: "0.75rem",
                    color: "var(--text-color-secondary)",
                    lineHeight: 1.2,
                  }}
                >
                  {child.currentGrade.name}
                </div>
              )}
            </span>

            {isActive && (
              <i
                className="pi pi-check-circle"
                style={{ fontSize: "0.85rem", color, marginLeft: "0.25rem" }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ChildSwitcher;
